import toArray from 'later/utils/to-array';

import type ArrayProxy from '@ember/array/proxy';
import type MetaAdAccountModel from 'later/models/meta-ad-account';

type MetaAdAccounts = MetaAdAccountModel[] | ArrayProxy<MetaAdAccountModel> | null | undefined;

/**
 * @param metaAdAccounts Collection of Meta ad accounts to check
 * @returns True when at least one ad account is not disconnected
 */
export default function hasConnectedAdAccount(metaAdAccounts: MetaAdAccounts): boolean {
  return toArray<MetaAdAccountModel>(metaAdAccounts).some((adAccount) => !adAccount.disconnectedTime);
}
